import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  root: {
    border: "1px solid #00000026",
    borderRadius: 3
  },
  label: {
    fontFamily: "Segoe UI",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#1E1E1E",
    marginBottom: 8
  },
  headerCell: {
    fontFamily: "Segoe UI",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#1E1E1E",
    borderTop: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    borderLeft: "1px solid #00000026",
    borderRight: "1px solid #00000026",
    padding: "0 8px",
    textAlign: "left",
    backgroundColor: "#E6E6E6",
    height: 24
  },
  bodyCell: {
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#464646",
    borderLeft: "1px solid #00000026",
    borderRight: "1px solid #00000026",
    padding: 8
  }
});
export interface TableColumn<T> {
  key: keyof T;
  header: React.ReactNode;
  render?: (row: T, idx: number) => React.ReactNode;
  cellProps?: React.ComponentProps<typeof TableCell>;
  headerCellProps?: React.ComponentProps<typeof TableCell>;
}

export interface TableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  rowKey?: (row: T, idx: number) => React.Key;
  tableProps?: React.ComponentProps<typeof MuiTable>;
  headRowProps?: React.ComponentProps<typeof TableRow>;
  bodyRowProps?: (row: T, idx: number) => React.ComponentProps<typeof TableRow>;
}

function Table<T>({
  columns,
  data,
  rowKey,
  tableProps,
  headRowProps,
  bodyRowProps
}: TableProps<T>) {
  const classes = useStyles();
  return (
    <TableContainer className={classes.root}>
      <MuiTable size="small" {...tableProps}>
        <TableHead>
          <TableRow {...headRowProps}>
            {columns.map(col => (
              <TableCell
                key={String(col.key)}
                {...col.headerCellProps}
                className={classes.headerCell}
                scope="col"
              >
                <span className={classes.label}>{col.header}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow
              key={rowKey ? rowKey(row, idx) : idx}
              {...(bodyRowProps ? bodyRowProps(row, idx) : {})}
            >
              {columns.map(col => (
                <TableCell
                  key={String(col.key)}
                  {...col.cellProps}
                  className={classes.bodyCell}
                >
                  {col.render ? col.render(row, idx) : row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}

export default Table;
